export const dataTypes = [
    'archetype',
    'archetypeSpecialSkills',
    'career',
    'careerSkillsRank',
    'creationCharacteristics',
    'critical',
    'currentStrain',
    'currentWound',
    'description',
    'earnedXP',
    'equipmentArmor',
    'equipmentGear',
    'equipmentWeapons',
    'masterMotivations',
    'masterSkills',
    'masterTalents',
    'misc',
    'money',
    'aember',
    'setting',
    'talentModifiers',
    'theme',
    'themes'
];

export const vehicleDataTypes = [
    'vehicleType',
    'currentHullTrauma',
    'currentSystemStrain',
    'vehicleNotes'
];

export const chars = [
    'Brawn',
    'Agility',
    'Intellect',
    'Cunning',
    'Willpower',
    'Presence'
];

export const diceOrder = [
    '[yellow]',
    '[green]',
    '[blue]',
    '[red]',
    '[purple]',
    '[black]',
    '[rmblack]',
    '[rmblackblack]'
];

export const diceNames = {
    '[blue]': { name: 'Boost Die' },
    '[black]': { name: 'Setback Die' },
    '[rmblack]': { name: 'Remove Setback Die' },
    '[rmblackblack]': { name: 'Remove 2 Setback Die' },
    '[success]': { name: 'Success' },
    '[advantage]': { name: 'Advantage' },
    '[failure]': { name: 'Failure' },
    '[threat]': { name: 'Threat' }
};

export const customDataTypes = [
    'customArchetypes',
    'customArchetypeTalents',
    'customArmor',
    'customCareers',
    'customGear',
    'customMotivations',
    'customSettings',
    'customSkills',
    'customTalents',
    'customVehicles',
    'customWeapons'
];

export const modifiableAttributes = [
    'woundThreshold',
    'strainThreshold',
    'soak',
    'meleeDefense',
    'rangedDefense',
    'defense',
    'careerSkills'
].sort();

export const books = ['CRB', 'RoT', 'SotB', 'SotC'];
